import generatedGitInfo from '../generatedGitInfo.json';
import Modal from './Modal';

interface AboutModalProps {
    open: boolean;
    onClose: () => void;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

const TermsAndConditions = ({
    open,
    onClose,
    maxWidth = 'md',
}: AboutModalProps) => {
    const handleClose = () => {
        onClose();
    };

    return (
        <Modal
            open={open}
            title="About"
            onClose={handleClose}
            maxWidth={maxWidth}
        >
            <div
                style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
            >
                <span>Lifespan Genome Portal</span>
                <span>{`Version: ${generatedGitInfo.gitCommitHash}`}</span>
                <span>
                    {`Date: ${new Date(
                        generatedGitInfo.gitCommitDate
                    ).toLocaleString()}`}
                </span>
            </div>
        </Modal>
    );
};

export default TermsAndConditions;
